import { render } from "./SaleSearch.vue?vue&type=template&id=25d10c60&scoped=true"
import script from "./SaleSearch.vue?vue&type=script&lang=js"
export * from "./SaleSearch.vue?vue&type=script&lang=js"

import "./SaleSearch.vue?vue&type=style&index=0&id=25d10c60&lang=scss&scoped=true"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d10c60"]])

export default __exports__